<template>

	<div class="d-flex justify-content-center h-100">

		<b-card
			v-if="!forgot"
			title="Sign in"
			style="max-width: 40rem;"
			class="mt-5"
		>
			<b-form @submit.prevent="loginSubmit">

				<b-input-group class="mb-3">

					<b-input-group-prepend is-text>
						<b-icon icon="file-person-fill"></b-icon>
					</b-input-group-prepend>

					<b-form-input
						type="email"
						placeholder="E-Mail"
						v-model="email"
						required
					></b-form-input>

				</b-input-group>

				<b-input-group class="mb-3">

					<b-input-group-prepend is-text>
						<b-icon icon="file-lock-fill"></b-icon>
					</b-input-group-prepend>

					<b-form-input
						type="password"
						placeholder="Password"
						v-model="password"
						required
					></b-form-input>

				</b-input-group>

				<p v-if="loginError">{{ loginError }}</p>

				<b-form-group>

					<b-button
						type="submit"
						variant="warning"
					>Log in</b-button>

				</b-form-group>
				<div class="d-flex justify-content-center">
					<a
						@click.prevent="forgot=true"
						href="#"
					>Forgot your password?</a>
				</div>
			</b-form>

		</b-card>

		<b-card
			v-else
			title="Send password reset link"
			style="max-width: 40rem;"
			class="mt-5"
		>

			<b-form @submit.prevent="sendPasswordLink">

				<b-input-group class="mb-3">

					<b-input-group-prepend is-text>
						<b-icon icon="file-person-fill"></b-icon>
					</b-input-group-prepend>

					<b-form-input
						type="email"
						placeholder="E-Mail"
						v-model="email"
						required
					></b-form-input>

				</b-input-group>

				<b-form-group>

					<b-button
						type="submit"
						variant="warning"
					>Send link</b-button>

				</b-form-group>

				<p v-if="message">{{ message }}</p>
			</b-form>

			<div class="d-flex justify-content-center">
				<a
					@click.prevent="forgot=false"
					href="#"
				>Go back</a>
			</div>

		</b-card>
	</div>

</template>

<script>

import AccountService from "@/api-services/account.service";
import { mapState, mapActions } from "vuex";

export default {
	data() {
		return {
			email: "",
			password: "",
			message: null,
			forgot: false,
		};
	},
	computed: {
		...mapState({
			loggingIn: (state) => state.account.loggingIn,
			loginError: (state) => state.account.loginError,
		}),
	},

	methods: {
		...mapActions(["doLogin"]),

		// we are watching checking the state of auth in the header, so when it changes it will push to the next url.
		loginSubmit() {
			this.doLogin({
				grant_type: "password",
				UserName: this.email,
				Password: this.password,
			});
		},

		sendPasswordLink() {
			AccountService.forgottenPassword({ Email: this.email })
				.then((response) => {
					this.message = "We sent you the thing";
				})
				.catch((error) => {
					this.message = error;
				});
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/account/login.vue